import { IThirdWebWallet } from "./IThirdWebWallet";
import { BaseInAppWallet } from "./BaseInAppWallet";
import { getUserEmail, preAuthenticate } from "thirdweb/wallets/in-app";
import { ThirdwebClient } from "thirdweb";
import { Web3Config } from "../../config/Web3Config";
import { ILogger } from "../../../cityversetycoon/logger/ILogger";
import { ThirdWebAnalytic } from "../../utils/ThirdWebAnalytic";

interface EmailConnectOptions {
    email: string;
    verificationCode: string;
}

export class InAppWallet extends BaseInAppWallet<EmailConnectOptions> implements IThirdWebWallet<EmailConnectOptions> {
    private emailValue: string;

    public get email(): string {
        return this.emailValue;
    }

    public constructor(client: ThirdwebClient, web3Config: Web3Config, thirdWebAnalytic: ThirdWebAnalytic, logger: ILogger) {
        super(client, web3Config, thirdWebAnalytic, logger, ["email"]);
    }

    public async sendVereficationEmail(email: string): Promise<void> {
        this.emailValue = email;
        await this.wrapOperation(() => preAuthenticate({
            strategy: "email",
            client: this.client,
            email
        }), "send verefication email");
    }

    public async connect(options: EmailConnectOptions): Promise<boolean> {
        try {
            await this.createEmbededAccount(options.email, options.verificationCode);
            this.connectDefaultSmartAccount();
            this.connectEthL1SmartAccount();

            if (this.connected) {
                this.emailValue = await this.wrapOperation(() => getUserEmail({ client: this.client }), "get user email");
                await Promise.all([this.updateUSDCBalance(), this.updateMONBalance()]);
                this.thirdWebAnalytic.trackConnectionEvent("connect");
            }
            return this.connected;
        }
        catch (e: any) {
            this.logger.debug(`Third web error caught: ${e?.message ?? e}`);
            throw e;
        }
    }

    public async autoConnect(): Promise<boolean> {
        try {
            this.embededAccount = await this.wrapOperation(() => this.embededWallet.autoConnect({
                client: this.client,
                chain: this.web3Config.targetChain
            }), "auto connect in-app wallet");
            this.connectDefaultSmartAccount(true);
            this.connectEthL1SmartAccount(true);
            if (this.connected) {
                this.emailValue = await this.wrapOperation(() => getUserEmail({ client: this.client }), "get user email");
                await Promise.all([this.updateUSDCBalance(), this.updateMONBalance()]);
                this.thirdWebAnalytic.trackConnectionEvent("auto-connect");
            }
            return this.connected;
        }
        catch (e: unknown) {
            this.logger.error(`[InAppWallet] Exception on auto connect wallet: `, e);
            return false;
        }
    }

    public override async disconnect(): Promise<void> {
        await super.disconnect();
        this.emailValue = null;
    }

    private async createEmbededAccount(email: string, verificationCode: string): Promise<boolean> {
        if (this.embededAccount != null) {
            return true;
        }
        this.embededAccount = await this.embededWallet.connect({
            client: this.client,
            strategy: "email",
            email,
            verificationCode,
            chain: this.web3Config.targetChain
        });
        return this.embededAccount != null;
    }
}